import {Component, OnInit, transition} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {TipoEstado} from '../../model/constantes';
import {UtilApi} from '../../service/api/util.api';
import {IMyDpOptions, IMyDateModel} from 'mydatepicker';
import {ConstantesApiService} from '../../service/api/constantes.api';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {FTA} from '../../model/catalogo';
import {ModalService} from '../../service/modal.service';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {
    FiltroMetadata,
    ResultadoFiltroFta,
    FiltroDadosFta,
    FiltroAlteracaoEstado,
    ResultadoFiltroFta2
} from '../../model/filtros';

@Component({
    selector: 'consulta-fluxos',
    templateUrl: './consulta-fluxos.html',
    styleUrls: ['./consulta-fluxos.css']
})

export class ConsultaFluxosComponent implements OnInit {

    constructor(public globalService: GlobalService, private modalService: ModalService, private utilApi: UtilApi, private router: Router, private constantesService: ConstantesApiService, public pesquisaService: PesquisasFiltroApiService) {
    }

    respostaDespacho = '';
    ftaDespachado = null;
    ftaExcluido = null;
    pesquisado = false;

    estados: Array<TipoEstado> = new Array<TipoEstado>();
    FTAs: ResultadoFiltroFta2 = new ResultadoFiltroFta2();

    numero = new FormControl('', []);
    nome = new FormControl('', []);
    estado = new FormControl('0', []);
    dtInicio = new FormControl('', []);
    dtFim = new FormControl('', []);
    irpagina = new FormControl('', []);

    pagina: number = 1;

    hoje: Date = new Date();
    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: false,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    ngOnInit() {
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, ConsultaFluxosComponent.prototype.carregarEstados);
        //this.utilApi.invocacaoRemotaComRetry(5, 1000, this, ConsultaFluxosComponent.prototype.pesquisar);
        this.pesquisado = false;
        this.respostaDespacho = '';
        this.ftaDespachado = null;
    }

    detalhesFTA(codigo, versao) {
        this.modalService.abrirPaginaModal('detalhe-fta-modal', {}, {
            'codigo': codigo,
            'versao': versao
        }, 'Detalhes FTA', 'Fechar')
            .subscribe(resp => {
                if (resp == 'despachoOk') {
                    this.pesquisar();
                    this.respostaDespacho = resp;
                    this.ftaDespachado = codigo;
                } else if (resp == 'exclusaoOk') {
                    this.pesquisar();
                    this.respostaDespacho = resp;
                    this.ftaExcluido = codigo;
                }
            });
    }

    editarFTA(codigo, versao) {
        this.router.navigate(['/fluxo-cliente-interno-completo', codigo, versao]);
    }

    carregarEstados() {
        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.pesquisar();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina--;
        this.pesquisar();
    }


    IrparaPargina() {

        if (this.irpagina.value != 0) {
            this.pagina = this.irpagina.value;
            this.pesquisar();
        }


    }

    pesquisar() {
        this.respostaDespacho = '';
        this.ftaDespachado = null;
        this.pesquisado = true;

        if ((this.dtInicio.value == '' && this.dtFim.value != '') || (this.dtInicio.value != '' && this.dtFim.value == '')) {
            this.modalService.exibirMensagem('Data de Criação', 'Por favor, preencha as datas de criação inicial e final ou deixe os dois campos em branco.', 'Fechar');
            return false;
        }

        this.FTAs = new ResultadoFiltroFta2;
        let filtros: Array<any> = new Array<any>();
        let filtroNumero: string = '0';
        let filtroNome: string = '';
        let filtroEstado: string = '0';
        let filtroFta: FiltroDadosFta = new FiltroDadosFta();
        let filtroAlteracaoEstado: FiltroAlteracaoEstado = new FiltroAlteracaoEstado();

        filtroFta.ordenacao = 'data';

        if (this.estado.value != '0') {
            filtroFta.codTipoEstado = this.estado.value;
        }
        if (this.numero.value != '') {
            filtroFta.fta = this.numero.value;
        }
        if (this.nome.value != '') {
            filtroFta.nome = this.nome.value;
        }

        if (this.dtInicio.value != '') {
            filtroAlteracaoEstado.codTipoEstado = 1;
            filtroAlteracaoEstado.dataInicial = this.dtInicio.value.jsdate;
            filtroAlteracaoEstado.dataFinal = this.dtFim.value.jsdate;
            filtros.push({'filtroFta': {'filtros': [{filtroFta}]}, filtroAlteracaoEstado});
        } else {
            filtros.push({'filtroFta': {'filtros': [{filtroFta}]}});
        }

        this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        this.pesquisaService.filtraFta2(filtros)
            .subscribe(
                listaItens => {
                    this.FTAs = listaItens as ResultadoFiltroFta2;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                }
            );
    }

    getEstado(codigo: Number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';
    }

    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }

}



// WEBPACK FOOTER //
// ./src/app/consulta-fluxos/consulta-fluxos.ts